import type { PrivacyNotice } from '@fleet/shared';
import { apiFetch } from './client';

/**
 * Die Datenschutzhinweise kommen vom Server, nicht aus dem Web-Bundle.
 *
 * Ein Teil des Textes hängt an der laufenden Konfiguration — vor allem, wie
 * genau Positionsdaten von Privatfahrten noch sind. Läge er hier, könnte er
 * etwas zusichern, was die Anlage nicht tut.
 */
export const privacyApi = {
  notice: () => apiFetch<PrivacyNotice>('/api/v1/privacy-notice'),
};
